module.exports = __webpack_public_path__ + "img/pdf-dwn.3f6c1ab6.png";